mutation CreateCountryAccess($input: CreateCountryAccessInput!) {
  createCountryAccess(input: $input) {
    id
    title
    type
    countries
    isDefault
  }
}
